import TeamsHeader from './TeamsHeader';
export { default as Search } from './Search';

export default TeamsHeader;
